import { useMemo } from 'react';
import * as THREE from 'three';
import type { Project, ResponsiveValues } from '../../types';
import { textureCache } from '../../hooks/media/useMediaLoader';
import vertexShader from '../../shaders/gallery/vertex.glsl';
import fragmentShader from '../../shaders/gallery/fragment.glsl';

export const useSpiralMaterials = (
  projects: Project[],
  values: ResponsiveValues,
  allMediaLoaded: boolean
) => {
  return useMemo(
    () =>
      projects.map(project => {
        const texture = textureCache.get(project.thumbnail);
        const aspectRatio = texture
          ? texture.image.width / texture.image.height
          : 16 / 9;

        const mat = new THREE.ShaderMaterial({
          vertexShader,
          fragmentShader,
          uniforms: {
            tDiffuse: { value: texture },
            hovered: { value: 0.0 },
            mousePos: { value: new THREE.Vector2(0.5, 0.5) },
            focused: { value: 0.0 },
            spiralRadius: { value: values.radius },
            spiralAngle: { value: 0.0 },
            heightLoop: { value: values.heightLoop },
            transitionProgress: { value: 0.0 },
            time: { value: 0.0 },
            scrollOffset: { value: 0.0 },
            colorTransition: { value: 0.0 },
            velocity: { value: 0.0 },
            curveStrength: { value: 0.2 },
            resolution: { value: new THREE.Vector2(aspectRatio, 1) },
          },
          transparent: true,
          side: THREE.DoubleSide,
          // Ajouter ces paramètres pour améliorer la qualité
          depthWrite: false,
          depthTest: true,
          // Activer le blending pour de meilleurs bords
          blending: THREE.NormalBlending,
        });
        return mat;
      }),
    [projects, values.radius, values.heightLoop, allMediaLoaded]
  );
};
